/* eslint-disable react/no-array-index-key */
import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { FaSpinner } from 'react-icons/fa';
import CustomHeader from '../../../components/CustomHeader';
import DwellerItem from '../../../components/DwellersList/DwellerItem';
import useShareModal from '../../../hooks/useShareModal';

const listGql = gql`
  query dwellers($condominiumId: ID!, $status: String) {
    dwellers(condominiumId: $condominiumId, status: $status) {
      _id
      name
      phoneNumber
      email
      unity(condominiumId: $condominiumId) {
        _id
        name
        status
        reason
        data
        permissions {
          vote
          comment
          view
        }
      }
    }
    condominium(condominiumId: $condominiumId) {
      _id
      name
      referral
      dwellersCount
    }
  }
`;

export default function OwnerList({ match }) {
  const { data, refetch, loading } = useQuery(listGql, {
    variables: {
      condominiumId: match.params.condominiumId,
      status: 'approved',
    },
  });
  const shareModal = useShareModal();
  const dwellers = useMemo(() => {
    if (!data || !data.dwellers) return [];
    return data.dwellers;
  }, [data]);

  const totalUsers = useMemo(() => {
    if (!data || !data.condominium) return 0;
    return data.condominium.dwellersCount || 0;
  });

  const PLURALIZATION_TOTAL_USERS = useMemo(() => (totalUsers > 1 ? 's' : ''), [totalUsers]);

  return (
    <div className="d-flex flex-column">
      <CustomHeader title="Condôminos" to="/dashboard" />
      <ul className="list-group">
        <li className="list-group-item d-flex justify-content-between align-items-center">
          <span className="text">{`${totalUsers} condômino${PLURALIZATION_TOTAL_USERS} `}</span>
          <button className="btn btn-primary" type="button" onClick={shareModal}>
            + Convidar
          </button>
        </li>
        {loading && (
          <li className="list-group-item d-flex justify-content-center align-items-center">
            <FaSpinner />
          </li>
        )}
        {dwellers.map(dweller => (
          <li className="list-group-item" key={dweller._id}>
            <DwellerItem dweller={dweller} onCompleted={refetch} submitOnChange />
          </li>
        ))}
      </ul>
    </div>
  );
}

OwnerList.propTypes = {
  match: propTypes.object.isRequired,
};
